module.exports = __webpack_public_path__ + "img/12.2cc3a918.png";